import { Client } from '@/utilities/api/Client';
import { QueryUtil } from '@/utilities/Query';
import { EnergyEndpoint } from '@api/endpoints/EnergyEndpoint';

export class EnergyApi {
  static completeBehavior (
    farmerId: string,
    behaviorId: string,
    body: EnergyEndpoint.CompleteBehavior.Request,
  ): Promise<EnergyEndpoint.CompleteBehavior.Response> {
    return Client(`energy/customers/${farmerId}/behaviors/${behaviorId}/complete`, {
      body,
      method: 'POST',
    });
  }

  static createProgram (
    body: EnergyEndpoint.CreateProgram.Request,
  ): Promise<EnergyEndpoint.CreateProgram.Response> {
    return Client('energy/programs', { body, method: 'POST' });
  }

  static getCustomer (farmerId: string): Promise<EnergyEndpoint.GetCustomer.Response> {
    return Client(`energy/customers/${farmerId}`);
  }

  static getCustomerBehaviorsTemplate (
    retailerId: string,
  ): Promise<EnergyEndpoint.GetCustomerBehaviorsTemplate.Response> {
    return Client(`energy/retailers/${retailerId}/customer-behaviors-template`);
  }

  static getDashboard (accessToken: string): Promise<EnergyEndpoint.GetDashboard.Response> {
    return Client(`energy/dashboard/${accessToken}`);
  }

  static getPointsActivity (
    accessToken: string,
    query: { page?: number, type?: 'all' | 'earned' | 'redeemed' },
  ): Promise<EnergyEndpoint.GetActivity.Response> {
    return Client(`energy/dashboard/${accessToken}/points-activity?${QueryUtil.stringify(query)}`);
  }

  static getProgram (id: string): Promise<EnergyEndpoint.GetProgram.Response> {
    return Client(`energy/programs/${id}`);
  }

  static initializeCustomers (
    programId: string,
  ): Promise<EnergyEndpoint.InitializeCustomers.Response> {
    return Client(`energy/programs/${programId}/initialize-customers`, { method: 'POST' });
  }

  static overrideTier (
    farmerId: string,
    body: EnergyEndpoint.OverrideTier.Request,
  ): Promise<EnergyEndpoint.OverrideTier.Response> {
    return Client(`energy/customers/${farmerId}/tier-override`, { body, method: 'POST' });
  }

  static previewReverse (
    farmerId: string,
    behaviorId: string,
  ): Promise<EnergyEndpoint.PreviewReverse.Response> {
    return Client(`energy/customers/${farmerId}/behaviors/${behaviorId}/reverse-preview`);
  }

  static reverseBehavior (
    farmerId: string,
    behaviorId: string,
    body: EnergyEndpoint.ReverseBehavior.Request,
  ): Promise<EnergyEndpoint.ReverseBehavior.Response> {
    return Client(`energy/customers/${farmerId}/behaviors/${behaviorId}/reverse`, {
      body,
      method: 'POST',
    });
  }

  static saveTiers (
    programId: string,
    body: EnergyEndpoint.SaveTiers.Request,
  ): Promise<EnergyEndpoint.SaveTiers.Response> {
    return Client(`energy/programs/${programId}/tiers`, { body, method: 'PUT' });
  }

  static setMemberships (
    farmerId: string,
    body: EnergyEndpoint.SetMemberships.Request,
  ): Promise<EnergyEndpoint.SetMemberships.Response> {
    return Client(`energy/customers/${farmerId}/memberships`, { body, method: 'PUT' });
  }

  static updateProgram (
    id: string,
    body: EnergyEndpoint.UpdateProgram.Request,
  ): Promise<EnergyEndpoint.UpdateProgram.Response> {
    return Client(`energy/programs/${id}`, { body, method: 'PATCH' });
  }
}
